module.exports = __webpack_public_path__ + "img/search.6444aef6.png";